import { AbstractParentEntity } from "./AbstractParentEntity";
export class AbstractGroup extends AbstractParentEntity {}
